import React, { useContext } from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import verticaldots from '../../../Assets/Images/vertical-dots.svg';
import viewicon from '../../../Assets/Images/wideView.svg';
import { InsightsContext } from '../../../Context/InsightsContext';

const COLORS = ['#ACC549', '#66D7DE', '#6A9DFF', '#836FFB', '#BA59E7', '#DB4CB2', '#F77DAA', '#EA7369', '#F48956', '#CCCCCC']
const COLORSIN = ['#ACC54980', '#66D7DE80', '#6A9DFF80', '#836FFB80', '#BA59E780', '#DB4CB280', '#F77DAA80', '#EA736980', '#F4895680', '#CCCCCC80']

const DailyWork = ({ setTableViewOpen }) => {

    const { top10OccupationalGroups,
        top10IndustryGroups,
        top10Occupations,
        top10Industries } = useContext(InsightsContext);

    const occupationGroups = top10OccupationalGroups.map(og => ({ name: og.occupational_group, value: og.totalcount }));
    const topOccupations = top10Occupations.map(oc => ({ name: oc.occupation, value: oc.count }));
    const occupations = [];
    top10OccupationalGroups.forEach((og, i) => occupations.push(...(Object.keys(og.occupations).map(oc => ({ name: oc, value: og.occupations[oc], index: i })))));

    const industryGroups = top10IndustryGroups.map(ig => ({ name: ig.industry_group, value: ig.totalcount }));
    const topIndustries = top10Industries.map(ic => ({ name: ic.industry, value: ic.count }));
    const industries = [];
    top10IndustryGroups.forEach((ig, i) => industries.push(...(Object.keys(ig.industries).map(ic => ({ name: ic, value: ig.industries[ic], index: i })))));

    const getLegendIndex = (name, arr) => {
        return arr.find(x => x.name === name)?.index;
    }

    const renderGroupLegend = (data) => (
        <ul>
            {data.map((entry, index) => (
                <li key={`item-${index}`}>
                    <div>
                        <span style={{ backgroundColor: COLORS[index % COLORS.length] }} className="legend-color-box" />
                        {entry.name}
                    </div>
                    {entry.value}
                </li>
            ))}
        </ul>
    );
    const renderLegend = (data, array) => (
        <ul>
            {data.map((entry, index) => (
                <li key={`item-${index}`}>
                    <div>
                        <span style={{ backgroundColor: COLORS[getLegendIndex(entry.name, array) % COLORS.length] }} className="legend-color-box" />
                        {entry.name}
                    </div>
                    {entry.value}
                </li>
            ))}
        </ul>
    );

    return (
        <div className="container daily-work">
            <div className="section">
                <div className="head bor-prop">
                    <h3>Occupations</h3>
                    <div>
                        <img src={viewicon} alt="view" onClick={() => setTableViewOpen(true)} />
                        <img src={verticaldots} alt="option" style={{ marginRight: "25px" }} />
                    </div>
                </div>

                <div className="chart-container">
                    <PieChart width={380} height={380} >
                        <Pie
                            data={occupations}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={160}
                            innerRadius={100}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {occupations.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[entry.index % COLORSIN.length]} />
                            ))}
                        </Pie>
                        <Pie
                            data={occupationGroups}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={100}
                            innerRadius={40}
                            fill="#82ca9d"
                            dataKey="value"
                        >
                            {occupationGroups.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORSIN[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>

                    <div className='legend legend-2'>
                        <h4>Top 10 Occupational Groups</h4>
                        {renderGroupLegend(occupationGroups)}
                    </div>
                    <div className='legend legend-1'>
                        <h4>Top 10 Occupations</h4>
                        {renderLegend(topOccupations, occupations)}
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="head bor-prop">
                    <h3>Industries</h3>
                    <div>
                        <img src={viewicon} alt="view" />
                        <img src={verticaldots} alt="option" style={{ marginRight: "25px" }} />
                    </div>
                </div>
                <div className="chart-container">
                    <PieChart width={380} height={380} >
                        <Pie
                            data={industries}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={160}
                            innerRadius={100}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {industries.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[entry.index % COLORSIN.length]} />
                            ))}
                        </Pie>
                        <Pie
                            data={industryGroups}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={100}
                            innerRadius={40}
                            fill="#82ca9d"
                            dataKey="value"
                        >
                            {industryGroups.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORSIN[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>

                    <div className='legend legend-2'>
                        <h4>Top 10 Industry Groups</h4>
                        {renderGroupLegend(industryGroups)}
                    </div>
                    <div className='legend legend-1'>
                        <h4>Top 10 Industries</h4>
                        {renderLegend(topIndustries, industries)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DailyWork;
